import ProgressBar from 'components/commons/progress-bar'
import Spinner from 'components/commons/spinner'
import { useEffect, useState } from 'react'
import { useFetch } from 'services/useFetch.js'
import { useImport } from '../ImportContext.jsx'

export const ValidateData = () => {
    const { title, api, payload, setActiveStep, setValidateData } = useImport()
    const [percentage, setPercentage] = useState(0)
    const { fetching: validateData, isLoading } = useFetch(api?.fetchValidate)

    useEffect(() => {
        if (percentage === 10) {
            ;(async () => {
                try {
                    const response = await validateData(payload, null, {'Content-Type': 'multipart/form-data'})
                    setValidateData(response?.data)
                } catch (e) {
                    setActiveStep(1)
                }
            })()
        }
    }, [percentage])

    useEffect(() => {
        let timeout = null
        if (percentage <= 80) {
            timeout = setTimeout(() => {
                setPercentage(percentage + 10)
            }, 1000)
        } else if (!isLoading) {
            timeout = setTimeout(() => {
                if (percentage === 100) {
                    setActiveStep(3)
                } else {
                    setPercentage(percentage + 10)
                }
            }, 1000)
        }

        return () => {
            clearTimeout(timeout)
        }
    }, [percentage, isLoading])

    return (
        <div className='flex flex-col items-center w-full text-neutral-80 space-y-8 px-40 py-16'>
            <Spinner className='w-10 h-10 !border-primary-50' />
            <div className='flex flex-col items-center space-y-2'>
                <p className='font-bold text-lg'>Validate Data</p>
                <p>{`Your ${title} data are now being Validate`}</p>
            </div>
            <div className='flex flex-col items-center w-full space-y-5 pt-8'>
                <ProgressBar percentage={percentage} />
                <p className='font-bold text-lg text-primary-60'>Progress in {percentage}%</p>
            </div>
        </div>
    )
}
